import React from "react";
import styled from "styled-components";
import fightingLogo from "../resources/fighting.png";
const UpgradePlanWarningContainer = styled.div`
  margin: auto;
  margin-top: 100px;
  width: 880px;
  display: flex;
`;

const Paragraph = styled.div`
  width: 640px;
  word-break: break-word;
  font-size: 16px;
  margin:10px;
`;

const Image = styled.img`
  width: 200px;
  margin-right: 30px;
`;
const header="These powerful reports are for UNLIMITED package. ";
const description_1 =` We offered various types of powerful analytical reports best for your
        company to understand employees better. 
        For example counseling break-down, stress reports and also including this report.`;
const save_the_date="Save the date! ";
const upgrade_to_unlimited_package="Upgrade to Unlimited Package ";
const now_to_gain_all_of_these_benefits="Now to gain all of these benefits.";
const UpgradePlanWarning = () => (
	<UpgradePlanWarningContainer>
		<Image src={fightingLogo} alt='fighting-logo'/>
		<div>
			<h2>{header}</h2>
			<Paragraph>
				{description_1}
			</Paragraph>
			<Paragraph>
				{save_the_date}
				<a href="https://ooca.co/corporate">
					{upgrade_to_unlimited_package}
				</a> 
				{now_to_gain_all_of_these_benefits}
			</Paragraph>
		</div>
	</UpgradePlanWarningContainer>
);

export default UpgradePlanWarning;



// WEBPACK FOOTER //
// ./src/containers/UpgradePlanWarning.js